import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "@/content/articles";
import { useCovers } from "./useCovers";

export const fmtIt = (iso) => new Date(`${iso}T00:00`).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });

export const ArticleCard = ({ a, i = 0, dark = false, cover }) => (
  <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: i * 0.1 }} className="h-full">
    <Link to={`/blog/${a.slug}`} data-testid={`article-card-${a.slug}`}
      className={`group h-full flex flex-col rounded-[1.75rem] p-7 border transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(27,59,40,0.45)] ${dark ? "bg-[#FCFBF7]/5 border-[#FCFBF7]/10" : "bg-[#FCFBF7] border-[#1B3B28]/10"}`}>
      {cover && (
        <div className="-mx-3 -mt-3 mb-6 aspect-[16/10] rounded-[1.25rem] overflow-hidden" data-testid={`article-card-cover-${a.slug}`}>
          <img src={cover} alt={a.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
        </div>
      )}
      <div className="flex items-center justify-between">
        <span className={`eyebrow ${dark ? "text-[#86C89B]" : "text-[#3E6B48]"}`}>{a.category}</span>
        <span className={`w-9 h-9 grid place-items-center rounded-full transition-transform duration-500 group-hover:rotate-45 ${dark ? "bg-[#86C89B] text-[#0F2317]" : "bg-[#E6ECE4] text-[#1B3B28]"}`}><ArrowUpRight size={16} /></span>
      </div>
      <h3 className={`f-serif text-3xl leading-[1.05] mt-8 ${dark ? "text-[#FCFBF7]" : "text-[#1B3B28]"}`}>{a.title}</h3>
      <p className={`text-sm leading-relaxed mt-4 ${dark ? "text-[#FCFBF7]/65" : "text-[#526356]"}`}>{a.description}</p>
      <p className={`f-mono text-xs tracking-[0.15em] uppercase mt-auto pt-8 ${dark ? "text-[#FCFBF7]/50" : "text-[#526356]"}`}>{a.readTime} min di lettura</p>
    </Link>
  </motion.div>
);

export const ArticleGrid = ({ items = ARTICLES, dark }) => {
  const covers = useCovers();
  return (
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      {items.map((a, i) => <ArticleCard key={a.slug} a={a} i={i} dark={dark} cover={covers[a.slug]} />)}
    </div>
  );
};
